<template>
  <v-container class="modal-container" data-app>
    <v-dialog
      v-model="modalVisible"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="logged"
          icon
          color="red"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            mdi-heart-plus
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          @click="notLoggedSnackBar()"
        >
          <v-icon>
            mdi-heart-plus
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="title"> Add to Favorite </v-card-title>
        <v-card-text>
          <v-form ref="form" class="form-visit">
            <v-select
              v-model="form.select"
              :items="form.favoriteList"
              item-text="name"
              item-value="id"
              label="Select a favorite list"
              return-object
              :rules="textareaRules"
              outlined
            ></v-select>
            <v-btn class="ma-2" @click="clearForm()">
              Cancel
            </v-btn>
            <v-btn class="success-btn ml-2" color="primary" @click="submitForm()">Confirm</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      right
      :multi-line="snackbarAtt"
      color="success"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          class="mr-3"
          icon
          color="black"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="snackbarNotLoggeed"
      :timeout="3500"
      bottom
      :multi-line="snackbarAttNotLoggeed"
    >
      {{ snackbarTextNotLoggeed }}

      <template v-slot:action="{ attrs }">
        <v-btn
          class="mr-3"
          icon
          color="red"
          text
          v-bind="attrs"
          @click="snackbarNotLoggeed = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Api from "../../services/api"

import RestaurantServices from "../../services/restaurant";


export default {
  name: "modal-favoris",

  props: ["modalVisible", "restaurant", "userToken","logged"],

  data: () => ({
    form : {
      select: {
        name: "",
        id:""
      },
      favoriteList : [],
    },
    snackbar : false,
    snackbarNotLoggeed : false,
    snackbarText : "",
    snackbarTextNotLoggeed : "",
    snackbarAtt : true,
    snackbarAttNotLogged : true,
    textareaRules: [
      v => !!v || "This field is required"
    ],
  }),

  methods: {
    async submitForm() {
      if (this.$refs.form.validate()) {
        try {
          let api = new Api()
          await api.addRestaurantToFavoriteList(this.form.select.id,this.restaurant.id,this.userToken)
          this.clearForm();
          this.snackbar = true;
          this.snackbarText = "Restaurant added to favorite List";
        } catch (err) {
          this.snackbar = true;
          this.snackbarText = err
        }

      }
    },

    cancelForm() {
      this.clearForm()
    },

    clearForm() {
      this.modalVisible = false;
      this.form.select.name = "";
      this.form.select.id = "";
    },

    async getFavoritesList() {
      this.api = new Api()
      const { data } = await this.api.getUserFavoritsLists(this.userToken.id);
      this.form.favoriteList = data.items;
    },

    notLoggedSnackBar() {
      this.snackbarNotLoggeed = true
      this.snackbarTextNotLoggeed = "You have to be logged in to use that function"
    }



  },

  async created() {
    await this.getFavoritesList()
  }
}

</script>

<style scoped>

</style>
